import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect } from 'react';
import useInfoNavigation from '../../../hooks/useInfoNavigation';
import QueryParamProxy from '../../../utils/queryParamProxy';
import routeParamConstants from '../../../utils/routeParamConstants';
import { generateInfoScreen } from '../utils/generateBattleRendering';
var useBattlesInfo = function useBattlesInfo(_ref) {
  var battlesAssets = _ref.battlesAssets;
  var hasTutorial = QueryParamProxy.findParam(routeParamConstants.PARAM_BATTLES_TUTORIAL, false);
  var infoNavigation = useInfoNavigation({
    tutorialScreens: generateInfoScreen(battlesAssets)
  });
  useEffect(function () {
    if (hasTutorial) {
      infoNavigation.handleOpenModal();
      QueryParamProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_BATTLES_TUTORIAL, undefined));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasTutorial]);
  return _objectSpread({}, infoNavigation);
};
export default useBattlesInfo;